import Vue from 'vue'
import { defineNuxtPlugin } from '@nuxtjs/composition-api'
import VueStarRating from 'vue-star-rating'

export default defineNuxtPlugin(() => {
  Vue.component('VueStarRating', VueStarRating)
})
